import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import config from '@/config';
import { Button, ButtonType, Heading, Text } from '@/modules/ui';

import { CopyIconButton } from '../../CopyIconButton';
import * as sharedRules from '../CreateApiKeyModal.rules';
import * as felaRules from './ApiKeyRevealStep.rules';

export interface ApiKeyRevealStepProps {
    apiKey: string;
    onDone: () => void;
}

export const ApiKeyRevealStep = ({ apiKey, onDone }: ApiKeyRevealStepProps) => {
    const { css } = useFela();

    return (
        <div className={css(sharedRules.content)}>
            <div className={css(sharedRules.body)}>
                <Heading elementType='h1' variant='h2' color='black'>
                    <FormattedMessage id='api-keys.create.reveal.title' />
                </Heading>
                <div className={css(sharedRules.group)}>
                    <Text color='foregroundsTertiary' customStyle={sharedRules.paragraph}>
                        <FormattedMessage id='api-keys.create.warning' />
                    </Text>
                    <div className={css(felaRules.field)}>
                        <Text variant='ParagraphSmallMedium' customStyle={felaRules.fieldText}>
                            {apiKey}
                        </Text>
                        <CopyIconButton value={apiKey} data-testid='copy-api-key-button' />
                    </div>
                </div>
                <div className={css(felaRules.baseUrl)}>
                    <Text variant='ParagraphSmallMedium' color='foregroundsTertiary'>
                        <FormattedMessage id='api-keys.baseUrl.label' />
                    </Text>
                    <div className={css(felaRules.field)}>
                        <Text variant='ParagraphSmallMedium' customStyle={felaRules.fieldText}>
                            {config.publicApi.baseUrl}
                        </Text>
                        <CopyIconButton value={config.publicApi.baseUrl} data-testid='copy-api-base-url-button' />
                    </div>
                    <Text variant='LabelLarge' color='foregroundsTertiary'>
                        <FormattedMessage id='api-keys.baseUrl.hint' />
                    </Text>
                </div>
            </div>
            <Button type={ButtonType.PRIMARY} onClick={onDone} customStyle={sharedRules.submitButton}>
                <FormattedMessage id='api-keys.create.done' />
            </Button>
        </div>
    );
};
